<template>
  <div class="app-two-columns-selector2 selector">
    <v-layout v-if="!existItems" class="red--text">
      <v-flex>選択可能な{{ itemName }}がありません</v-flex>
    </v-layout>
    <v-layout>
      <v-flex grow style="flex-basis: 300px">
        <v-layout>
          <v-flex xs5>
            <v-subheader>{{ broadCategoryLabel }}</v-subheader>
          </v-flex>
          <v-flex xs4>
            <v-subheader style="padding-right: 10px">
              {{ subCategoryLabel }}
            </v-subheader>
          </v-flex>
          <v-flex class="inline-block text-xs-right" xs3>
            <v-btn
              v-if="canAllSelectFilteredSecondItems"
              @click="selectAllLeft"
              :disabled="filteredSecondItemsList.length === 0"
            >
              すべて選択
            </v-btn>
            <v-btn v-else @click="reverseAllLeft">選択を解除</v-btn>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs5>
            <select multiple class="left-select-list-one select-list-height">
              <option
                v-for="item in leftEndItems"
                :key="item.id + item.name"
                @click.prevent="selectLeftEndItem(item)"
                :class="['list-item px-2', { isSelected: item.selected }]"
              >
                {{ item.name }}
                <span v-if="item.selected">▶</span>
              </option>
            </select>
          </v-flex>
          <v-flex class="sub-left-select-list">
            <v-text-field
              v-if="useSearch"
              v-model="keyword"
              @input="inputKeyword"
              @keypress.enter.exact="shiftSearchItem(1)"
              @keypress.enter.shift="shiftSearchItem(-1)"
              append-icon="search"
              placeholder="検索"
              background-color="white"
              class="search-box"
              solo
            >
              <template v-slot:append v-if="searchCount">
                <div>{{ searchIndex + 1 }}/{{ searchCount }}</div>
                <v-icon @click="shiftSearchItem(-1)" small>arrow_upward</v-icon>
                <v-icon @click="shiftSearchItem(1)" small
                  >arrow_downward</v-icon
                >
              </template>
            </v-text-field>
            <ul
              ref="selector"
              :class="[
                useSearch === true
                  ? 'left-select-list-two small-select-list-height'
                  : 'left-select-list-one select-list-height',
              ]"
              multiple
            >
              <slot v-if="!isSelectedLeftEndItem" />
              <li
                ref="option"
                v-for="item in filteredSecondItemsList"
                :key="item.id + item.name"
                @click.prevent="selectItem(item)"
                @dblclick.prevent="instantMoveRight(item)"
                :class="['list-item px-2', { isSelected: item.selected }]"
              >
                {{ item.name }}
              </li>
            </ul>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex align-self-center shrink>
        <v-layout class="move-button align-self-center" column>
          <v-btn @click="moveRight" :disabled="disabledRightButton" icon large>
            <v-icon x-large>arrow_right</v-icon>
          </v-btn>
          <v-btn @click="moveLeft" :disabled="disabledLeftButton" icon large>
            <v-icon x-large>arrow_left</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
      <v-flex grow style="flex-basis: 300px">
        <v-layout>
          <v-flex xs6>
            <v-subheader>{{ rightLabel }}</v-subheader>
          </v-flex>
          <v-flex class="inline-block text-xs-right" xs6>
            <v-btn
              v-if="canAllSelectRightItems"
              @click="selectAllRight"
              :disabled="rightItems.length === 0"
            >
              すべて選択
            </v-btn>
            <v-btn v-else @click="reverseAllRight">選択を解除</v-btn>
          </v-flex>
        </v-layout>
        <select multiple class="right-select-list select-list-height">
          <option
            v-for="item in rightItems"
            :key="item.id + item.name"
            @click.prevent="selectItem(item)"
            @dblclick.prevent="instantMoveLeft(item)"
            :class="['list-item px-2', { isSelected: item.selected }]"
          >
            {{ item.parentName }} > {{ item.name }}
          </option>
        </select>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import differenceWith from 'lodash/differenceWith'
import concat from 'lodash/concat'

const compareIds = (a, b) => {
  return a.parentId === b.parentId && a.id === b.id
}

export default {
  name: 'AppThreeColumnsSelector',
  props: {
    broadCategoryList: {
      type: Array,
      default: () => [],
    },
    subCategoryList: {
      type: Array,
      default: () => [],
    },
    addedIdAndNameList: {
      type: Array,
      default: () => [],
    },
    broadCategoryLabel: {
      type: String,
      default: '',
    },
    subCategoryLabel: {
      type: String,
      default: '',
    },
    rightLabel: {
      type: String,
      default: '',
    },
    itemName: {
      type: String,
      default: '',
    },
    useSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leftEndItems: [],
      secondLeftItems: [],
      rightItems: [],
      keyword: '',
      searchIndex: 0,
      searchCount: null,
    }
  },
  computed: {
    existItems() {
      return this.broadCategoryList.length > 0
    },
    disabledRightButton() {
      return this.getSelectItems(this.secondLeftItems).length === 0
    },
    disabledLeftButton() {
      return this.getSelectItems(this.rightItems).length === 0
    },
    isSelectedLeftEndItem() {
      return this.leftEndItems.some(item => item.selected === true)
    },
    filteredSecondItemsList() {
      this.secondLeftItems.map(item => (item.selected = false))
      return this.secondLeftItems
    },
    canAllSelectFilteredSecondItems() {
      if (this.filteredSecondItemsList.length === 0) return true
      return this.filteredSecondItemsList.some(item => item.selected === false)
    },
    canAllSelectRightItems() {
      if (this.rightItems.length === 0) return true
      return this.rightItems.some(item => item.selected === false)
    },
  },
  watch: {
    broadCategoryList() {
      this.makeLeftEndItems()
    },
    addedIdAndNameList() {
      this.setItems()
    },
    subCategoryList() {
      this.setItems()
    },
  },
  created() {
    this.makeLeftEndItems()
    this.setItems()
  },
  methods: {
    setItems() {
      this.rightItems = this.makeRightItems()
      this.secondLeftItems = this.makeSecondLeftItems()
    },
    makeLeftEndItems() {
      this.leftEndItems = this.broadCategoryList
    },
    makeSecondLeftItems() {
      this.secondLeftItems = this.subCategoryList
      return differenceWith(this.secondLeftItems, this.rightItems, compareIds)
    },
    makeRightItems() {
      return this.addedIdAndNameList
    },
    selectAllLeft() {
      this.filteredSecondItemsList.map(item => (item.selected = true))
    },
    selectAllRight() {
      this.rightItems.map(item => (item.selected = true))
    },
    reverseAllLeft() {
      this.filteredSecondItemsList.map(item => (item.selected = false))
    },
    reverseAllRight() {
      this.rightItems.map(item => (item.selected = false))
    },
    selectItem(item) {
      item.selected = !item.selected
    },
    selectLeftEndItem(item) {
      this.leftEndItems.map(target => (target.selected = false))
      item.selected = !item.selected
      this.$emit('setSecondLeftItems', item.id, item.name)
    },
    moveRight() {
      this.emitSetIds(
        concat(
          this.addedIdAndNameList,
          this.getSelectItems(this.secondLeftItems),
        ),
      )
      this.clearAllSelected(this.getSelectItems(this.secondLeftItems))
    },
    moveLeft() {
      const selectItems = this.getSelectItems(this.rightItems)
      this.emitSetIds(
        differenceWith(this.addedIdAndNameList, selectItems, compareIds),
      )
    },
    clearAllSelected(list) {
      list.map(item => (item.selected = false))
    },
    getSelectItems(list) {
      return list.filter(item => item.selected)
    },
    instantMoveRight(item) {
      this.emitSetIds(concat(this.addedIdAndNameList, item))
    },
    instantMoveLeft(item) {
      this.emitSetIds(
        differenceWith(this.addedIdAndNameList, [item], compareIds),
      )
    },
    emitSetIds(idAndNameList) {
      this.sortList(idAndNameList)
      this.$emit('setIds', idAndNameList)
    },
    sortList(list) {
      return list.sort(function(a, b) {
        if (a.parentId < b.parentId) return -1
        if (a.parentId > b.parentId) return 1
        else {
          if (a.id < b.id) return -1
          if (a.id > b.id) return 1
        }
        return 0
      })
    },
    inputKeyword: debounce(function() {
      this.searchIndex = 0
      this.search()
    }, 1000),
    search() {
      this.putOnHighLightTag()
      this.scroll(0)
      this.searchCount = document.getElementsByClassName('has-keyword').length
    },
    putOnHighLightTag() {
      const spanTagStart = '<span style="background-color: #fddb67;">'
      const spanTagEnd = '</span>'

      this.$refs.option.forEach(option => {
        // spanタグがあれば、取り除く
        const spanTagEndRE = new RegExp(spanTagEnd, 'g')
        option.innerHTML = option.innerHTML.replace(
          /<span style="background-color: #[0-9a-fA-F]+;">/,
          '',
        )
        option.innerHTML = option.innerHTML.replace(spanTagEndRE, '')
        option.classList.remove('has-keyword')
        // 検索ワードをspanタグで囲む
        if (this.keyword) {
          const keywordRE = new RegExp(this.keyword, 'g')
          if (option.innerHTML.match(keywordRE)) {
            option.innerHTML = option.innerHTML.replace(
              keywordRE,
              `${spanTagStart}${this.keyword}${spanTagEnd}`,
            )
            option.classList.add('has-keyword')
          }
        }
      })
    },
    scroll(index, shiftIndex) {
      this.$refs.selector.scrollTop = 0
      const searchElement = document.getElementsByClassName('has-keyword')[
        index
      ]
      // 移動前のindex
      const preventIndex =
        (index + this.searchCount - shiftIndex) % this.searchCount
      const preventSearchElement = document.getElementsByClassName(
        'has-keyword',
      )[preventIndex]
      if (searchElement) {
        searchElement.innerHTML = searchElement.innerHTML.replace(
          '#fddb67', // 黄色
          '#ff7e41', // オレンジ
        )
        if (this.searchCount != 1 && preventSearchElement)
          preventSearchElement.innerHTML = preventSearchElement.innerHTML.replace(
            '#ff7e41', // オレンジ
            '#fddb67', // 黄色
          )
        this.$refs.selector.scrollTop =
          searchElement.getBoundingClientRect().top -
          this.$refs.selector.getBoundingClientRect().top
      }
    },
    shiftSearchItem(number) {
      this.searchIndex = (this.searchIndex + number) % this.searchCount
      // indexが[-]の時は最後尾に戻る
      if (this.searchIndex < 0) this.searchIndex += this.searchCount
      this.scroll(this.searchIndex, number)
    },
  },
}
</script>

<style scoped lang="scss">
.v-btn {
  margin: 0 0 5px 10px;
  height: 32px;
  width: 40px;
  font-size: 12px;
}
.selector {
  min-height: 60px;
}
.subheader {
  color: rgba(0, 0, 0, 0.54);
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
}
.search-box {
  min-height: 0;
  min-width: 100%;
  display: inline-block;
  color: black !important;
}
.move-button {
  margin: 55px 10px 0 0;
}
.left-select-list-one {
  width: 100%;
  border: 1px solid black;
  overflow-y: scroll;
}
.left-select-list-two {
  width: 100%;
  border: 1px solid black;
  overflow-y: scroll;
  overflow-x: scroll;
  list-style: none;
}
.right-select-list {
  width: 100%;
  border: 1px solid black;
  overflow-y: scroll;
  overflow-x: scroll;
}
.right-subheader {
  margin-top: -15px;
}
.list-item {
  cursor: pointer;
  &.isSelected {
    background-color: rgba(#1976d2, 0.6);
  }
}
.sub-left-select-list {
  width: 250px;
}
.select-list-height {
  height: 150px;
}
.small-select-list-height {
  height: 118px;
}
</style>
